// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"142":"7c031b2b","170":"7c031b2b","236":"7c031b2b","346":"7c031b2b","405":"4e8a80d7","568":"7c031b2b","665":"b6f4a1e9","946":"7c031b2b"}[chunkId] + ".chunk.css";
};